import type { Activity } from '../types/activity';

/**
 * 組出在 Google Maps 開啟行程地點的網址。有 placeId 時帶 query_place_id 精準定位；
 * 沒有座標/placeId 的行程（例如手動輸入地點）仍以地點名稱搜尋，只有完全沒有可搜尋文字時才回傳 null。
 */
export function getGoogleMapsUrl(
  activity: Pick<Activity, 'name' | 'location' | 'address' | 'placeId'>
): string | null {
  const text = activity.location || activity.address || activity.name;
  if (!text) return null;
  const query = encodeURIComponent(text);
  const placeIdParam = activity.placeId ? `&query_place_id=${activity.placeId}` : '';
  return `https://www.google.com/maps/search/?api=1&query=${query}${placeIdParam}`;
}
